import { axiosPost, axiosGet } from '../ServiceBase.js';

/**
 * Validar token consulta Orden Electrónica api call
 * @returns
 */
export const validarTokenConsulta = async (data) => {
  return axiosPost('/v1/orden-digital/validar-token-consulta', data);
};

/**
 * Validar Orden Electrónica consulta api call
 * @returns
 */
export const validarOrdenDigitalConsulta = async (data) => {
  return axiosPost('/v1/orden-digital/validar-orden-digital-consulta', data);
};

/**
 * Generar Orden Electrónica api call
 * @returns
 */
export const generarOrdenDigital = async (data) => {
  return axiosPost('/v1/orden-digital/generar-orden-digital', data);
};

/**
 * Autorizar acceso a prescripciones electrónicas del afiliado
 * @returns
 */
export const autorizarPrescripciones = async (data) => {
  return axiosPost('/v1/orden-digital/autorizar-prescripciones', data);
};

// HARDCODE TEMPORAL: Reemplazo de WebSocket por polling HTTP.
// Motivo: nginx en producción no permite conexiones WebSocket desde el browser de mi-iosper.
// Mientras no se resuelva la config de nginx, mi-iosper consulta el estado del trámite
// via polling a este endpoint en lugar de escuchar mensajes WebSocket.
// Cuando nginx se corrija, eliminar este método y restaurar createWebSocketConnection()
// en GenerarOrdenDigital.js.
export const consultarEstadoTramite = async (token) => {
  return axiosGet(`/v1/orden-digital/estado-tramite?token=${token}`);
};
